<script setup lang="ts">import { toRef as _toRef, computed as _computed } from 'vue';

import {
  faArrowRight,
  faLocationArrow,
  faSearch,
  faWandMagicSparkles,
  faLink,
} from '@fortawesome/pro-light-svg-icons'
import Result from './Result.vue'
import { backgroundFor, defaultIconFor, hintFor, detectHotWord, textFor } from './utils'
import genericPlace from './generic-place.svg'
import { useOmniSearch } from './useOmniSearch'
import Tip from './Tip.vue'

const __$temp_1 = (useOmniSearch()),
  searchResponse = _toRef(__$temp_1, 'searchResponse'),
  showAllResultsValue = _toRef(__$temp_1, 'showAllResultsValue'),
  trimmedQuery = _toRef(__$temp_1, 'trimmedQuery');

const showAllResultsText = _computed(() => {
  return `Show results for "${searchResponse.value?.zipCity || trimmedQuery.value}"`
})

const hotWord = _computed(() => trimmedQuery.value && detectHotWord(trimmedQuery.value))
const hotWordContent = _computed(() => hotWord.value?.hotWord)
const hotWordUrl = _computed(() => import.meta.env.SSR ? '' : window.location.origin + hotWordContent.value?.url)
</script>

<template>
  <div v-if="searchResponse" ref="resultsContainer" class="text-sm">
    <Tip v-if="searchResponse.proTip" proTip :text="searchResponse.proTip"/>

    <div class="results">
      <Result
        v-if="searchResponse.nearbySuggestion"
        :value="{ search: { category: searchResponse.nearbySuggestion, city: 'Nearby' }}"
        :text="`${searchResponse.nearbySuggestion} nearby`"
        :icon="faLocationArrow"
      />
      <Result
        v-for="result in searchResponse.results"
        :key="result.text"
        :value="result"
        :text="textFor(result)"
        :icon="defaultIconFor(result)"
        :imageUrl="backgroundFor(result, searchResponse.city)"
        :hint="hintFor(result, searchResponse)"
        :giftlyMetadata="result.giftlyMetadata"
      />
      <Result
        v-if="!hotWord && !searchResponse.zipCity"
        :text="showAllResultsText"
        :icon="faSearch"
        :value="showAllResultsValue"
      />
    </div>
    <div v-if="searchResponse.suggestions.length" class="suggestions flex flex-col gap-4">
      <div class="text-v2-secondary">Suggested gift ideas</div>
      <div class="flex flex-wrap gap-2">
        <Result
          v-for="suggestion in searchResponse.suggestions"
          :key="suggestion.text"
          :value="suggestion"
          :icon="defaultIconFor(suggestion)"
          :text="textFor(suggestion)"
          :imageUrl="backgroundFor(suggestion, searchResponse.city)"
          :hint="hintFor(suggestion)"
          :giftlyMetadata="suggestion.giftlyMetadata"
          withBorder
          truncate
        />
      </div>
    </div>
    <div class="generic-suggestion flex flex-col gap-4">
      <div class="flex flex-col">
        <Result
          v-if="hotWord"
          :text="hotWordContent?.text"
          :hint="hotWordUrl"
          :value="hotWord"
          :icon="faLink"
          class="flex-grow"
        >
          <template #addonRight>
            <GIcon :icon="faArrowRight"/>
          </template>
        </Result>
        <Result
          v-else-if="searchResponse.genericSuggestion"
          hint="Works anywhere"
          :value="{ generic: { tagline: searchResponse.genericSuggestion }}"
          :text="searchResponse.genericSuggestion"
          :imageUrl="genericPlace"
          class="flex-grow"
        >
          <template #addonRight>
            <GIcon :icon="faArrowRight"/>
          </template>
        </Result>
        <Result
          v-if="searchResponse.magicSuggestion"
          hint="Works anywhere"
          :value="{ generic: { tagline: searchResponse.magicSuggestion }}"
          :text="searchResponse.magicSuggestion"
          :imageUrl="undefined"
          :icon="faWandMagicSparkles"
          class="flex-grow"
        >
          <template #addonRight>
            <GIcon :icon="faArrowRight"/>
          </template>
        </Result>
      </div>
    </div>
  </div>
</template>
